var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9806 0.990181C16.7208 0.997922 16.4742 1.1065 16.2931 1.29292L6.00008 11.5859L2.70712 8.29292C2.61497 8.19694 2.5046 8.12032 2.38247 8.06753C2.26034 8.01475 2.12891 7.98686 1.99587 7.98551C1.86283 7.98416 1.73086 8.00936 1.60768 8.05965C1.4845 8.10994 1.3726 8.1843 1.27852 8.27838C1.18444 8.37246 1.11008 8.48436 1.05979 8.60754C1.0095 8.73072 0.984294 8.86269 0.985647 8.99573C0.987001 9.12877 1.01489 9.26021 1.06767 9.38233C1.12046 9.50446 1.19708 9.61483 1.29305 9.70698L5.29305 13.707C5.4806 13.8944 5.73491 13.9998 6.00008 13.9998C6.26526 13.9998 6.51957 13.8944 6.70712 13.707L17.7071 2.70698C17.8516 2.56652 17.9503 2.38567 17.9903 2.18815C18.0302 1.99063 18.0096 1.78565 17.931 1.60007C17.8525 1.41448 17.7197 1.25695 17.5501 1.14812C17.3805 1.03929 17.182 0.98424 16.9806 0.990181Z",
    fill: "#00C305"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdIcon);
export default __webpack_public_path__ + "static/media/birdIcon.03c184b8377122932795c80b6efd6c6b.svg";
export { ForwardRef as ReactComponent };